
import { Component,OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { extend, Internationalization } from '@syncfusion/ej2-base';
import { MonthService,CurrentAction,EventSettingsModel,ResourcesModel,CellClickEventArgs,EJ2Instance, ScheduleComponent, EventRenderedArgs, PopupOpenEventArgs} from '@syncfusion/ej2-angular-schedule';
import { TextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-programmazione-calendar',
  templateUrl: './programmazione-calendar.component.html',
  styleUrls: ['./programmazione-calendar.component.css'],
  providers: [ MonthService],
  encapsulation: ViewEncapsulation.None
})
export class ProgrammazioneCalendarComponent implements OnInit {
  isReadOnly:boolean=true;
  scheduleData: Object[] = [];
   listFields:any[]=[];
     pageTitle:string='';
     listParams:any={};
     struttureList:any[]=[];
     newRecordUrl:string='';
     editRecordUrl:string='';
     deleteRecordUrl:string='';
    
     
     struttura_id:number=0;
    
     constructor(
        private apiService: ApiService,
        private globalService: GlobalService,
     ) { }
  


  @ViewChild('scheduleObj')
  public scheduleObj?: ScheduleComponent;
  @ViewChild('eventTypeObj')
  public eventTypeObj?: DropDownListComponent;
  @ViewChild('titleObj')
  public titleObj?: TextBoxComponent;
  @ViewChild('notesObj')
  public notesObj?: TextBoxComponent;
  public eventSettings: EventSettingsModel = { dataSource: <Object[]>extend([], [], undefined, true) };
  public selectedDate: Date = new Date();
  public intl: Internationalization = new Internationalization();
  public roomFields: Object = { text: 'Name', value: 'Id' };
  public roomData: Object[] = [
      { Name: 'Pranzo', Id: 1,  Color: '#ea7a57' },
      { Name: 'Cena', Id: 2,  Color: '#7fa900' },
   
  ];
  ngOnInit(): void {
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
   
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
        this.changeStruttura();
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
        if(this.struttura_id){
          this.changeStruttura();
        }
      }
    });
  }

  
  userCannotChangeStruttura(){
     if(this.globalService.loggedUser.struttura_id){
      return true;
     } else {
      return false;
     }
  }


  public getResourceData(data: { [key: string]: Object }): { [key: string]: Object } {
      // tslint:disable-next-line: deprecation
      const resources: ResourcesModel = this.scheduleObj!.getResourceCollections()[0];
     const resourceData: { [key: string]: Object } = (resources.dataSource as Object[]).filter((resource: Object) =>
  (resource as { [key: string]: Object; })['Id'] === data['Pasto'])[0] as { [key: string]: Object };
      return resourceData;
  }


  public getHeaderStyles(data: { [key: string]: Object }): Object {
      if (data['elementType'] === 'cell') {
          return { 'align-items': 'center', 'color': '#919191' };
      } else {
          const resourceData: { [key: string]: Object } = this.getResourceData(data);
          return { 'background': resourceData['Color'], 'color': '#FFFFFF' };
      }
  }

  public getHeaderTitle(data: { [key: string]: Object }): string {
      return (data['elementType'] === 'cell') ? 'Add Appointment' : 'Appointment Details';
  }

  
  public getEventType(data: { [key: string]: string }): string {
      const resourceData: { [key: string]: Object } = this.getResourceData(data);
      return resourceData['Name'] as string;
  }

  
   changeStruttura(event=null){
    if(event){
      this.struttura_id=event.value;
    }
    this.listParams.struttura_id=this.struttura_id;
    let f=this.struttureList.filter((x)=>x.value==this.struttura_id);

    this.pageTitle="Calendario mensa struttura: "+f[0].text;
    localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
    if(this.struttura_id){
      this.apiService.get('mensa/mensa_situazione',{struttura_id:this.struttura_id}).subscribe((data)=>{

        console.log(this.eventSettings.dataSource);
        this.scheduleObj.setProperties({ 
          eventSettings: { dataSource: data.Result } 
        });
        this.scheduleObj.refreshEvents();
      });
    }
    
  
    }

    onPopupOpen(args: PopupOpenEventArgs): void {
    if (args.type === 'QuickInfo' || args.type === 'Editor') {
        // Utilizza un piccolo timeout per attendere che la popup sia renderizzata nel DOM
        setTimeout(() => {
            if (args.element && (args.element as any).ej2_instances) {
                const popupObj = (args.element as any).ej2_instances[0];
                popupObj.refreshPosition();
            }
        }, 100);
    }
  }

    onEventRendered(args: EventRenderedArgs): void {
      const postiliberi = args.data['PostiLiberi']; // Assumi che esista un campo 'Category'
      
      // Condizione basata sui dati dell'evento
      if(postiliberi<10) {
        args.element.style.backgroundColor = 'Orange'; // Rosso per urgenti
      } else if (postiliberi<=0) {
        args.element.style.backgroundColor = 'Red'; // Verde per personali
      } else if (args.data['stato']=='sospeso') {
        args.element.style.backgroundColor = 'Darkgrey'; // Verde per personali
      }
    }

}
